export default __webpack_public_path__ + "static/media/montana.4e051119.jpg";